const mutations = {
    PAYMENT_LOADING: (state) => {
        state.paymentStatus = 'loading';
    },
    PAYMENT_SUCCESS: (state, data) => {
        state.paymentStatus = 'success';
        // state.payments = data.payments;
        Vue.set(state, 'payments', data.payments);
        // state.paymentsCount = data.payments_count;
        Vue.set(state, 'paymentsCount', data.payments_count);
    },
    PAYMENT_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.paymentStatus = 'error';
        state.paymentErrors.record(errors);
    },
    PAYMENT_SENT_SUCCESS: (state) => {
        state.paymentStatus = '';
    },
    PAYMENT_SENT_ERROR: (state) => {
        state.paymentStatus = 'error';
    },
    CLEAR_PAYMENT_ERRORS: (state) => {
        state.paymentStatus = '';
        state.paymentErrors.clear();
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
